export default __webpack_public_path__ + "static/etched-1480c16c784eeb42d9ad28bdab49144e.png";